import { createSelector } from '@ngrx/store';

import { CUSTOMER_ID } from './config/user-details.const';
import { selectSharedState, State } from '../../reducer';
import { UserDetailsState, CurrentUser, BranchDetails } from './state';

export const getUserDetailsState = createSelector(
  selectSharedState,
  (state: State) => state.userDetails
);

export const selectCurrentUser = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state?.currentUser
);

export const selectCurrentUserBidcompAccess = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state?.currentUser?.hasBidCompAccess
);

export const selectCurrentUserMMDAccess = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state?.currentUser?.hasMMDAccess
);

export const selectCurrentUserIsInsurancePremiumIncluded = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) =>
    state?.currentUser?.isInsurancePremiumIncluded
);

export const selectBranchDetails = createSelector(
  getUserDetailsState,
  (state: UserDetailsState) => state?.branchDetails
);

export const isSelectedAndLoggedInBranchDifferent = createSelector(
  selectCurrentUser,
  selectBranchDetails,
  (currentUser: CurrentUser, branchDetails: BranchDetails) =>
    branchDetails?.selectedBranch ? currentUser?.customerId !== branchDetails.selectedBranch : false
);

export const selectedCustomerId = createSelector(
  selectCurrentUser,
  selectBranchDetails,
  (
    currentUser: CurrentUser,
    branchDetails: BranchDetails
  ) => {
    const currentUserID = currentUser?.customerId;
    const branchDetailsSelected = branchDetails?.selectedBranch;
    const branchIdFromSession = sessionStorage.getItem(CUSTOMER_ID);

    if (branchDetailsSelected) {
      return branchDetailsSelected;
    }

    return currentUserID === branchIdFromSession
      ? currentUserID
      : branchIdFromSession;
  }
);

export const selectBranchLabel = createSelector(
  selectCurrentUser,
  selectBranchDetails,
  selectedCustomerId,
  (
    currentUser: CurrentUser,
    branchDetails: BranchDetails,
    customerId: string
  ) => {
    if (currentUser?.customerId === customerId) {
      return '';
    }

    const { longName, city, state } = (branchDetails?.branches ?? [])
      .find(branch => branch?.customerId === customerId) ?? {};

    return `${longName} - ${city}, ${state}`;
  }
);
